import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { ShareCard } from "./student/ProgressCard";
import { ArrowRight, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

export default function PublicProgressCard() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/share/progress/${token}`)
      .then((r) => setCard(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Link not found"));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
        <div className="text-center max-w-md">
          <h1 className="font-display text-2xl font-bold">Link unavailable</h1>
          <p className="text-slate-600 mt-2">{error}</p>
          <Link to="/" className="inline-block mt-6"><Button className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Go to PrepMasters</Button></Link>
        </div>
      </div>
    );
  }
  if (!card) {
    return <div className="min-h-screen grid place-items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  }

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 gap-6" data-testid="public-progress-card">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">PrepMasters · Shared Progress</div>
      <ShareCard card={card} footnote={card.shared_at?.slice(0, 10)} />
      <div className="text-center mt-2 max-w-md">
        <h2 className="font-display text-xl font-bold">Inspired to prepare smarter?</h2>
        <p className="text-slate-600 text-sm mt-1">Join PrepMasters and start your own AI-assisted board exam review.</p>
        <Link to="/register"><Button className="mt-4 bg-[#1E3A8A] hover:bg-[#1E40AF]" data-testid="public-cta-btn">Start your review <ArrowRight className="w-4 h-4 ml-2" /></Button></Link>
      </div>
    </div>
  );
}
